import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ALTERNATIVE_FORMULA = 'Alternative Formula'
export const FORMULA_TYPE = 'formula type'
export const ADD_CONDITION = 'add condition'
export const ADD_CONDITION_MESSAGE = 'add condition message'
export const DEFAULT_SWITCH = 'default switch'

export default {
  [PORTUGUESE]: {
    [ALTERNATIVE_FORMULA]: 'Fórmula alternativa',
    [FORMULA_TYPE]: 'Tipo de Fórmula',
    [ADD_CONDITION]: 'Adicionar condição',
    [ADD_CONDITION_MESSAGE]: 'Nenhuma pergunta disponível para usar a fórmula em',
    [DEFAULT_SWITCH]: 'Tipo de fórmula não suportado encontrado',
  },

  [ENGLISH]: {
    [ALTERNATIVE_FORMULA]: 'Alternative Formula',
    [FORMULA_TYPE]: 'Formula Type',
    [ADD_CONDITION]: 'Add condition',
    [ADD_CONDITION_MESSAGE]: 'No question available to use formula on',
    [DEFAULT_SWITCH]: 'Unsupported formula type found',
  },

  [SPANISH]: {
    [ALTERNATIVE_FORMULA]: 'Fórmula alternativa',
    [FORMULA_TYPE]: 'Tipo de fórmula',
    [ADD_CONDITION]: 'Agregar condición',
    [ADD_CONDITION_MESSAGE]: 'No hay preguntas disponibles para usar la fórmula en',
    [DEFAULT_SWITCH]: 'Tipo de fórmula no admitido encontrado',
  },
}
